import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IPagination, IPaginationResultFrequencies } from "app/common/interfaces";
import { andAllWhere, buildQuery, FilterFn, Ops, orderBy, OrderVariant, page, where } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { ExpenseReasonAttributes } from "@albatrosdeveloper/ave-models-package";
import { IFilters } from "../../filters/interfaces/filterInterface";

const apiUrl = env.API_UNIT_MEASURE;
const moduleName = "expense_reason";

@Injectable({
  providedIn: "root",
})
export class ExpenseReasonService extends AbstractService<ExpenseReasonAttributes, ExpenseReasonAttributes, ExpenseReasonAttributes> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
     * Pagination
     * @param options Pagination options
     * @returns Paginated data
     */
    findAllWithCount(
      options: IPagination<ExpenseReasonAttributes>,
      dataToFilter?: IFilters
    ): Observable<IPaginationResultFrequencies<ExpenseReasonAttributes>> {

      const arrayQueries: FilterFn<ExpenseReasonAttributes>[] = [];

      if (dataToFilter?.status && dataToFilter?.status.length > 0 && !dataToFilter?.status.includes(null)) {
        arrayQueries.push(andAllWhere('statusId', Ops.in(...dataToFilter.status)))
      }

      if (dataToFilter?.subRouteId && dataToFilter?.subRouteId.length > 0) {
        arrayQueries.push(andAllWhere('subRoutesBySalesOffices._id' as keyof ExpenseReasonAttributes, Ops.in(...dataToFilter.subRouteId)))
      }
      
      const query = buildQuery<ExpenseReasonAttributes>(
        where("_deleted", Ops.eq(false)),
        
        ...arrayQueries,

        orderBy(
          options.sort ?? "createdAt",
          options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
        ),
        page(options.currentPage ?? 1, options.limitPerPage ?? 100)
      );
  
      const API_URL: string =
        apiUrl +
        `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
      return this.http.get<IPaginationResultFrequencies<ExpenseReasonAttributes>>(API_URL);
    }
}
